import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3e26fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closest-node-container cursor-pointer" }
const _hoisted_2 = {
  style: {"width":"100%","height":"100%"},
  class: "add-new-node-container routerNodeContent flex flex-col items-center justify-content-center"
}
const _hoisted_3 = {
  key: 0,
  fill: "#fff",
  width: "13",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "routerNodeContent flex flex-col items-center" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "addNodeDataContainer items-center h-full justify-center flex flex-col" }
const _hoisted_11 = { class: "w-full flex items-center justify-center output-icon" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "addNodeDataContainer items-center h-full justify-center flex flex-col" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "h-full add-new-node-container" }
const _hoisted_16 = {
  key: 0,
  class: "h-full flex flex-col items-center justify-between"
}
const _hoisted_17 = { class: "h-full flex flex-col w-full" }
const _hoisted_18 = { class: "d-flex align-items-center width-100 justify-content-center logo-header" }
const _hoisted_19 = { class: "img-box d-flex align-items-center justify-content-center" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ghost-img-div" }, null, -1))
const _hoisted_22 = { class: "text-section w-full" }
const _hoisted_23 = { class: "w-full flex items-center justify-center output-icon" }
const _hoisted_24 = { class: "nodeTitle" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "addNodeDataContainer items-center h-full justify-center flex flex-col"
}

import {
  onUpdated,
  ref,
  onMounted,
  onUnmounted,
  watch,
  computed,
  nextTick,
} from "vue";
import { ElTooltip } from "element-plus";
import { NodeProps, Position, Handle } from "@vue-flow/core";
import { ASSETS_BASE_URL, getResolution } from "@/core/logo";
import i18n from "@/core/i18n/i18n";
import { checkIsLoop, checkIsLoopEnd, checkIsLoopStep } from "@/core/util";
import { canRemoveNode, isNodeDetachedFromFlow } from "@/flow/utils/nodeUtils";
import type { RemovalGraphLookup } from "@/flow/utils/nodeUtils";
import { isStepInRouterBranch } from "@/flow/utils/nodeRenderLookups";
import type { RouterBranchLookup } from "@/flow/utils/nodeRenderLookups";
import { getSkipMenuState } from "@/flow/utils/skipUtils";
import { hasStepSummary } from "@/flow/utils/stepInputSummary";
import { CustomData, CustomEvents, CustomNodeTypes } from "./FlowDiagram.vue";
import CustomDropdown from "./CustomDropdown.vue";
import NodeInputSummary from "./NodeInputSummary.vue";
import NodeDelaySummary from "./NodeDelaySummary.vue";

interface ICustomNodeProps {
  type: "node" | "router";
  selectedStep?: any;
  nodeInfo: NodeProps<CustomData, CustomEvents, CustomNodeTypes> | null;
  listIndex?: string;
  selectedNodeId?: string | null;
  checkForLoopAndEndByType?: any;
  clonedStep?: any;
  nodes?: any;
  edges?: any[];
  removalGraph?: RemovalGraphLookup;
  routerBranchLookup?: RouterBranchLookup;
  logs?: any;
  nodesDraggable: boolean;
  isNextStepLoop?: boolean;
  isNextStepLoopEnd?: boolean;
  flowLog?: any;
  stepList?: any[];
  activeLoopReferenceOrigIds?: ReadonlySet<string>;
  /**
   * Show the configured-inputs hover card. Set only by the wizard approval preview — not inferred
   * from `nodesDraggable`, which is also false in other read-only states.
   */
  showInputSummary?: boolean;
}

// emits here defines in object format because there are muliple parameters in functions so
// to make the parameters type safe we use the object synx of defining emits here.

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomNode',
  props: {
    type: { default: "node" },
    selectedStep: {},
    nodeInfo: { default: null },
    listIndex: {},
    selectedNodeId: {},
    checkForLoopAndEndByType: {},
    clonedStep: {},
    nodes: {},
    edges: {},
    removalGraph: {},
    routerBranchLookup: {},
    logs: {},
    nodesDraggable: { type: Boolean },
    isNextStepLoop: { type: Boolean },
    isNextStepLoopEnd: { type: Boolean },
    flowLog: { default: null },
    stepList: {},
    activeLoopReferenceOrigIds: {},
    showInputSummary: { type: Boolean, default: false }
  },
  emits: ["setSelectedNodeId", "open-drawer", "align-left", "align-right", "openRouterSettings", "openLoopSettings", "add-node", "remove-node", "remove-router", "add-router", "open-filter", "delay", "clone-step", "paste-step", "open-output", "toggle-lock", "skip-step", "enable-step", "addOrRemoveExpressionType", "addNodeAfterStart"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const { t } = i18n.global;
const currentNode = ref(null);
const previousSelectedNodeId = ref(null);
const dropdownAnchorRef = ref<HTMLElement | null>(null);

// Same-ID node wrappers should not repeat the graph walk. Graph replacements and
// relevant in-place edits still invalidate eligibility through reactive reads.
const nodeOrigId = computed(() => props.nodeInfo?.data?.origId);
const canRemoveCurrentNode = computed(() =>
  canRemoveNode(nodeOrigId.value, props.nodes, props.edges, props.removalGraph)
);
const isFirstRouterBranchStep = computed(() =>
  isStepInRouterBranch(
    props.nodeInfo?.data,
    props.nodes,
    props.routerBranchLookup
  )
);

const hasNodeSummary = computed(() => hasStepSummary(props?.nodeInfo?.data));

/**
 * Keeps a badge card off the flow it describes.
 *
 * The badge hangs off the node's left edge, which is the one crowded side — the incoming edge and
 * the previous step live there. A flow runs left to right, so the free space is above and below:
 * open downward, and let Popper flip upward, then sideways, when the canvas edge gets in the way.
 * `preventOverflow` keeps it inside the visible canvas rather than letting it clip.
 */
const BADGE_POPPER_OPTIONS = {
  modifiers: [
    {
      name: "flip",
      options: { fallbackPlacements: ["top-start", "right", "left"] },
    },
    { name: "preventOverflow", options: { padding: 8 } },
  ],
};
// The input card wraps the whole node, so a badge inside it would open a second popper on top of
// the first. Element Plus listens on the reference element, so the card steps aside instead.
const badgeHovered = ref(false);
const isLoop = computed(() => checkIsLoop(props?.nodeInfo?.data));
const isLoopStep = computed(() => checkIsLoopStep(props?.nodeInfo?.data));
const isRouterNode = computed(
  () =>
    props.type === "router" ||
    String(props?.nodeInfo?.data?.type ?? "").toUpperCase() === "ROUTER"
);
const skipMenuState = computed(() =>
  getSkipMenuState(
    props?.nodeInfo?.data,
    props.stepList || [],
    props.activeLoopReferenceOrigIds
  )
);
const isSkipped = computed(() => skipMenuState.value.isSkipped);

onMounted(() => {
  setCurrentNode();
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

watch(
  () => props.selectedNodeId,
  (oldVal) => {
    // Store the previous selected node ID
    previousSelectedNodeId.value = oldVal;
  }
);
watch(
  () => props.nodes,
  () => {
    setCurrentNode();
  }
);
function setCurrentNode() {
  if (props.nodes) {
    currentNode.value = props.nodes.find(
      (node) => props.nodeInfo.data.origId === node.data.origId
    );
  }
}
onUpdated(() => {
  // Reset the zIndex of the previously selected node
  if (previousSelectedNodeId.value) {
    const prevElement = document.querySelector(
      `[data-id="${previousSelectedNodeId.value}"]`
    ) as HTMLElement;
    if (prevElement) {
      prevElement.style.zIndex = "0";
    }
  }

  // Set the zIndex of the current selected node
  const { selectedNodeId } = props;
  if (selectedNodeId) {
    const element = document.querySelector(
      `[data-id="${selectedNodeId}"]`
    ) as HTMLElement;
    if (element) element.style.zIndex = "99999";
  }
});

function openLoopSettings(data, label, listIndex) {
  emit("openLoopSettings", data, label, listIndex);
}

function handleClickOutside(event) {
  if (!event.target.closest(".closest-node-container")) {
    if (props.selectedNodeId) {
      emit("setSelectedNodeId", null);
    }
  }
}

function handleRemoveNode(id: string, step: any, index, parentId?: string) {
  emit("remove-node", {
    id,
    step,
    index,
    parentId,
  });
}

function openDrawer(step, index, listIndex) {
  emit("open-drawer", step, index, `step${listIndex}-${index}`);
  if (props.selectedNodeId) {
    nextTick(() => {
      emit("setSelectedNodeId", null);
    });
  }
}

function getNodeDisplayNumber(stepData: any): number {
  const stepNumber = Number(stepData?.stepNumber);
  if (Number.isFinite(stepNumber) && stepNumber > 0) {
    return stepNumber;
  }
  const ix = Number(stepData?.ix);
  if (Number.isFinite(ix)) {
    return ix + 1;
  }
  return 1;
}

function getNodeBadgeFontSize(stepData: any): string {
  return getNodeDisplayNumber(stepData) > 99 ? "8px" : "12px";
}

function isDetachedNode(nodeData: any) {
  return isNodeDetachedFromFlow(nodeData);
}

function canAddAfterNode(nodeData: any) {
  return props?.nodesDraggable && !isDetachedNode(nodeData);
}

function getHandleStyle(nodeData: any) {
  if (isSkipped.value) {
    return {
      backgroundColor: "#98a2b3",
      borderColor: "#d8dee6",
    };
  }
  if (!isDetachedNode(nodeData)) return undefined;

  return {
    backgroundColor: "#98a2b3",
    borderColor: "#d8dee6",
  };
}

function setHighlightForStartNode() {
  if (props.flowLog?.isAuthenticationFail) {
    return "highlight-failed";
  }
  return "";
}

function setHighlight(
  status,
  connection,
  nodeActiveStatus,
  missingIncomingChain,
  invalidLoopBackConnection = false,
  skipped = false
) {
  const classes = [];

  if (invalidLoopBackConnection) {
    classes.push("highlight-failed");
  } else if (skipped) {
    classes.push("highlight-skipped");
  } else if (missingIncomingChain) {
    classes.push("highlight-detached");
  } else if (!nodeActiveStatus && nodeActiveStatus !== null) {
    classes.push("highlight-detached");
  } else if (connection && connection.active === false) {
    classes.push("highlight-danger");
  } else {
    switch (status) {
      case "TRIGGERED":
        classes.push("emptyCase");
        break;
      case "COMPLETED":
        classes.push("highlight-success");
        break;
      case "FAILED":
        classes.push("highlight-failed");
        break;
      case "RUNNING":
      case "STARTED":
        classes.push("highlight-running");
        break;
      default:
        classes.push("");
    }
  }

  return classes;
}

function removeButtonPosition(isActive) {
  if (isActive) return "remove-button";
  return "";
}

function addButtonPosition(isActive) {
  if (isActive) return "add-button";
  return "";
}

function setHighlightStepNumber(connection) {
  if (connection && connection.active === false) {
    return "highlight-danger";
  }
  return "secondary-border";
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElTooltip), {
      effect: "custom",
      placement: "right",
      "show-after": 250,
      "hide-after": 0,
      disabled: !_ctx.showInputSummary || !hasNodeSummary.value || badgeHovered.value,
      "popper-class": "node-summary-popper"
    }, {
      content: _withCtx(() => [
        _createVNode(NodeInputSummary, {
          step: _ctx.nodeInfo?.data
        }, null, 8, ["step"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.nodeInfo?.type === 'start')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["custom-start-end flex items-center justify-center", [_ctx.nodeInfo?.type, setHighlightForStartNode()]])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.nodeInfo.type === 'start')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.nodeInfo.label), 1),
                  (_ctx.nodesDraggable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('addNodeAfterStart')), ["stop"])),
                        class: "start-add-node-button flex items-center justify-center"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          style: {"position":"relative","left":"3px"},
                          icon: "plus",
                          size: "sm"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : (_ctx.type === 'router')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref_key: "dropdownAnchorRef",
                  ref: dropdownAnchorRef,
                  class: _normalizeClass([
          'custom-router flex items-center justify-center',
          setHighlight(
            _ctx.logs?.status,
            _ctx.nodeInfo?.data?.connection,
            null,
            _ctx.nodeInfo?.data?.missingIncomingChain,
            _ctx.nodeInfo?.data?.invalidLoopBackConnection,
            isSkipped.value
          ),
          { 'detached-node': isDetachedNode(_ctx.nodeInfo?.data) },
          { 'skipped-node': isSkipped.value },
        ]),
                  id: `router${_ctx.listIndex}`,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('openRouterSettings', _ctx.nodeInfo.data,Number(_ctx.nodeInfo.label), _ctx.listIndex))),
                  onContextmenu: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('setSelectedNodeId', _ctx.nodeInfo.data.origId)), ["prevent"]))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["d-flex justify-content-center align-items-center primary-bg secondary-border number-box-shadow step-number-badge", {
             'detached-step-number-badge': isDetachedNode(_ctx.nodeInfo?.data),
             'skipped-step-number-badge': isSkipped.value,
           }]),
                    style: _normalizeStyle({ fontSize: getNodeBadgeFontSize(_ctx.nodeInfo.data) })
                  }, [
                    _createElementVNode("span", null, _toDisplayString(getNodeDisplayNumber(_ctx.nodeInfo.data)), 1)
                  ], 6),
                  _createElementVNode("div", {
                    class: "routerContentContainer",
                    id: `router-unique-${_ctx.nodeInfo?.data?.uniqueId}`
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.EditCondition")), 1)
                    ])
                  ], 8, _hoisted_7),
                  (canRemoveCurrentNode.value && _ctx.nodesDraggable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleRemoveNode(_ctx.nodeInfo.data.id, _ctx.nodeInfo.data, Number(_ctx.nodeInfo.label), _ctx.nodeInfo?.data?.parentId)), ["stop"])),
                        class: "remove-router-container remove-container absolute flex items-center justify-center"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          style: {"width":"8px","height":"8px"},
                          icon: "times",
                          size: "xs"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_6))
              : (_unref(checkIsLoop)(_ctx.nodeInfo.data))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    ref_key: "dropdownAnchorRef",
                    ref: dropdownAnchorRef,
                    class: _normalizeClass([
        'custom-node relative color-loop',
        setHighlight(
          _ctx.logs?.status,
          _ctx.nodeInfo?.data?.connection,
          null,
          _ctx.nodeInfo?.data?.missingIncomingChain,
          _ctx.nodeInfo?.data?.invalidLoopBackConnection,
          isSkipped.value
        ),
        { 'detached-node': isDetachedNode(_ctx.nodeInfo?.data) },
        { 'skipped-node': isSkipped.value },
        { highlight: (_ctx.selectedStep?.stepId || _ctx.selectedStep?.id) === _ctx.nodeInfo?.data?.id },
      ]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (openLoopSettings(_ctx.nodeInfo.data, Number(_ctx.nodeInfo.label), _ctx.listIndex))),
                    id: _ctx.nodeInfo?.data.id
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex justify-content-center align-items-center primary-bg secondary-border number-box-shadow step-number-badge", {
             'detached-step-number-badge': isDetachedNode(_ctx.nodeInfo?.data),
             'skipped-step-number-badge': isSkipped.value,
           }]),
                      style: _normalizeStyle({ fontSize: getNodeBadgeFontSize(_ctx.nodeInfo.data) })
                    }, [
                      _createElementVNode("span", null, _toDisplayString(getNodeDisplayNumber(_ctx.nodeInfo.data)), 1)
                    ], 6),
                    _createElementVNode("div", {
                      onContextmenu: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (emit('setSelectedNodeId', _ctx.nodeInfo.data.origId)), ["prevent"])),
                      class: "h-full add-new-node-container"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "redo",
                          size: "xl"
                        }),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.Loop")), 1)
                      ]),
                      (_ctx.nodeInfo.data?.output && _ctx.nodesDraggable)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (emit('open-output', Number(_ctx.nodeInfo.label), _ctx.nodeInfo.data)), ["stop"])),
                            class: "flex justify-content-start font-bold nodeBody ml-auto"
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "database",
                                color: "white"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (canRemoveCurrentNode.value && _ctx.nodesDraggable)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(['remove-node-container remove-container absolute flex items-center justify-center']),
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (handleRemoveNode(_ctx.nodeInfo.data.id, _ctx.nodeInfo.data, Number(_ctx.nodeInfo.label), _ctx.nodeInfo?.data?.parentId)), ["stop"]))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              style: {"width":"8px","height":"8px"},
                              icon: "times",
                              size: "xs"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (canAddAfterNode(_ctx.nodeInfo?.data))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (emit('add-node', _ctx.nodeInfo.data)), ["stop"])),
                            class: _normalizeClass(['add-node add-new-node-or-router flex items-center justify-center', addButtonPosition(_ctx.selectedStep?.id === _ctx.nodeInfo?.data.id)])
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              style: {"position":"relative","left":"3px","width":"9px"},
                              icon: "plus",
                              size: "sm"
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 32)
                  ], 10, _hoisted_9))
                : (_unref(checkIsLoopEnd)(_ctx.nodeInfo.data))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      ref_key: "dropdownAnchorRef",
                      ref: dropdownAnchorRef,
                      class: _normalizeClass([
        'custom-node relative color-loop-end',
        setHighlight(
          _ctx.logs?.status,
          _ctx.nodeInfo?.data?.connection,
          null,
          _ctx.nodeInfo?.data?.missingIncomingChain,
          _ctx.nodeInfo?.data?.invalidLoopBackConnection,
          isSkipped.value
        ),
        { 'detached-node': isDetachedNode(_ctx.nodeInfo?.data) },
        { 'skipped-node': isSkipped.value },
        { highlight: (_ctx.selectedStep?.stepId || _ctx.selectedStep?.id) === _ctx.nodeInfo?.data?.id }
      ]),
                      id: _ctx.nodeInfo?.data.id
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex justify-content-center align-items-center primary-bg secondary-border number-box-shadow step-number-badge", {
          'detached-step-number-badge': isDetachedNode(_ctx.nodeInfo?.data),
          'skipped-step-number-badge': isSkipped.value,
        }]),
                        style: _normalizeStyle({ fontSize: getNodeBadgeFontSize(_ctx.nodeInfo.data) })
                      }, [
                        _createElementVNode("span", null, _toDisplayString(getNodeDisplayNumber(_ctx.nodeInfo.data)), 1)
                      ], 6),
                      _createElementVNode("div", {
                        onContextmenu: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (emit('setSelectedNodeId', _ctx.nodeInfo.data.origId)), ["prevent"])),
                        class: "h-full add-new-node-container"
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "stop",
                            size: "xl"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.LoopEnd")), 1)
                        ]),
                        (canAddAfterNode(_ctx.nodeInfo?.data))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (emit('add-node', _ctx.nodeInfo.data)), ["stop"])),
                              class: _normalizeClass(['add-node add-new-node-or-router flex items-center justify-center', addButtonPosition(_ctx.selectedStep?.id === _ctx.nodeInfo?.data.id)])
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"position":"relative","left":"3px","width":"9px"},
                                icon: "plus",
                                size: "sm"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 32)
                    ], 10, _hoisted_12))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      ref_key: "dropdownAnchorRef",
                      ref: dropdownAnchorRef,
                      class: _normalizeClass([
        'custom-node relative',
        setHighlight(
          _ctx.logs?.status,
          _ctx.nodeInfo?.data?.connection,
          _ctx.nodeInfo.data.active,
          _ctx.nodeInfo?.data?.missingIncomingChain,
          _ctx.nodeInfo?.data?.invalidLoopBackConnection,
          isSkipped.value
        ),
        { 'detached-node': isDetachedNode(_ctx.nodeInfo?.data) },
        { 'skipped-node': isSkipped.value },
        { highlight: (_ctx.selectedStep?.stepId || _ctx.selectedStep?.id) === _ctx.nodeInfo?.data?.id },
      ]),
                      id: _ctx.nodeInfo?.data.id,
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (openDrawer(_ctx.nodeInfo?.data, Number(_ctx.nodeInfo.label), _ctx.listIndex))),
                      onContextmenu: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (emit('setSelectedNodeId', _ctx.nodeInfo.data.origId)), ["prevent"]))
                    }, [
                      (currentNode.value?.predecessor || currentNode.value?.successor)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["d-flex justify-content-center align-items-center primary-bg number-box-shadow step-number-badge", [
        setHighlightStepNumber(_ctx.nodeInfo?.data?.connection),
        { 'detached-step-number-badge': isDetachedNode(_ctx.nodeInfo?.data) },
        { 'skipped-step-number-badge': isSkipped.value },
      ]]),
                            style: _normalizeStyle({ fontSize: getNodeBadgeFontSize(_ctx.nodeInfo.data) })
                          }, [
                            _createElementVNode("span", null, _toDisplayString(getNodeDisplayNumber(_ctx.nodeInfo.data)), 1)
                          ], 6))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.nodeInfo.data?.connection || _ctx.nodeInfo.data?.connectorSpecId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("img", {
                                      class: "logo-step-header",
                                      src: `${_unref(ASSETS_BASE_URL)}/${_ctx.nodeInfo?.data?.connection?.connector?.connectorSpecId ?? _ctx.nodeInfo?.data?.connectorSpecId}${_unref(getResolution)(true)}.png`,
                                      alt: "logo"
                                    }, null, 8, _hoisted_20)
                                  ]),
                                  _hoisted_21
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", {
                                    class: "flex align-items-center justify-content-between",
                                    style: _normalizeStyle({ pointerEvents: _ctx.nodesDraggable || _ctx.showInputSummary ? 'auto' : 'none' })
                                  }, [
                                    (_ctx.nodeInfo.data?.delay && (_ctx.nodesDraggable || _ctx.showInputSummary))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.nodesDraggable && emit('delay', Number(_ctx.nodeInfo.label), _ctx.nodeInfo.data)), ["stop"])),
                                          class: _normalizeClass(['flex justify-content-start font-bold nodeBody mr-auto', { 'nodeBody-static': !_ctx.nodesDraggable }])
                                        }, [
                                          _createVNode(_unref(ElTooltip), {
                                            effect: "custom",
                                            placement: "bottom-start",
                                            "show-after": 250,
                                            disabled: !_ctx.showInputSummary,
                                            "popper-options": BADGE_POPPER_OPTIONS
                                          }, {
                                            content: _withCtx(() => [
                                              _createVNode(NodeDelaySummary, {
                                                step: _ctx.nodeInfo?.data
                                              }, null, 8, ["step"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: "w-full flex items-center justify-center delay-icon",
                                                onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (badgeHovered.value = true)),
                                                onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (badgeHovered.value = false))
                                              }, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: "hourglass-start",
                                                  color: "white"
                                                })
                                              ], 32)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ], 2))
                                      : _createCommentVNode("", true),
                                    (_ctx.nodeInfo.data?.output && _ctx.nodesDraggable)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (emit('open-output', Number(_ctx.nodeInfo.label), _ctx.nodeInfo.data)), ["stop"])),
                                          class: "flex justify-content-start font-bold nodeBody ml-auto"
                                        }, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: "database",
                                              color: "white"
                                            })
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 4),
                                  _createElementVNode("div", _hoisted_24, [
                                    (_ctx.nodeInfo?.data?.name?.length! > 60)
                                      ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                          key: 0,
                                          placement: "bottom",
                                          effect: "custom",
                                          content: _ctx.nodeInfo?.data.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.nodeInfo?.data.name.substring(0, 60)) + "... ", 1)
                                          ]),
                                          _: 1
                                        }, 8, ["content"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.nodeInfo?.data.name), 1))
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "plus",
                                size: "xl"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.Add")), 1)
                            ])),
                        (canRemoveCurrentNode.value && _ctx.nodesDraggable && !isFirstRouterBranchStep.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(['remove-node-container remove-container absolute flex items-center justify-center', removeButtonPosition(_ctx.selectedStep?.id === _ctx.nodeInfo?.data.id)]),
                              onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (handleRemoveNode(_ctx.nodeInfo.data.id,_ctx.nodeInfo.data, Number(_ctx.nodeInfo.label), _ctx.nodeInfo?.data?.parentId)), ["stop"]))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"width":"8px","height":"8px"},
                                icon: "times",
                                size: "xs"
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (canAddAfterNode(_ctx.nodeInfo?.data))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (emit('add-node', _ctx.nodeInfo.data)), ["stop"])),
                              class: _normalizeClass(['add-node add-new-node-or-router flex items-center justify-center', addButtonPosition(_ctx.selectedStep?.id === _ctx.nodeInfo?.data.id)])
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                style: {"position":"relative","left":"3px"},
                                icon: "plus",
                                size: "sm"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ], 42, _hoisted_14)),
          _createVNode(CustomDropdown, {
            top: 40,
            left: 36,
            anchorEl: dropdownAnchorRef.value,
            isMenuVisible: _ctx.selectedNodeId === _ctx.nodeInfo.data.origId && _ctx.nodesDraggable,
            selectedNodeId: _ctx.selectedNodeId,
            onAddNew: _cache[19] || (_cache[19] = ($event: any) => (emit('add-node', _ctx.nodeInfo.data))),
            onLoop: _cache[20] || (_cache[20] = ($event: any) => (emit('addOrRemoveExpressionType', _ctx.nodeInfo.data, 'LOOP', Number(_ctx.nodeInfo.label)))),
            onEnd: _cache[21] || (_cache[21] = ($event: any) => (emit('addOrRemoveExpressionType', _ctx.nodeInfo.data, 'END', Number(_ctx.nodeInfo.label)))),
            onRemove: _cache[22] || (_cache[22] = ($event: any) => (handleRemoveNode(_ctx.nodeInfo.data.id, _ctx.nodeInfo.data, Number(_ctx.nodeInfo.label), _ctx.nodeInfo?.data?.parentId))),
            onOpenFilter: _cache[23] || (_cache[23] = ($event: any) => (emit('open-filter', Number(_ctx.nodeInfo.label), _ctx.nodeInfo.data))),
            onAddRouter: _cache[24] || (_cache[24] = ($event: any) => (emit('add-router', _ctx.nodeInfo.data.id))),
            onSetSelectedNodeId: _cache[25] || (_cache[25] = ($event: any) => (emit('setSelectedNodeId', null))),
            onDelay: _cache[26] || (_cache[26] = ($event: any) => (emit('delay', Number(_ctx.nodeInfo.label), _ctx.nodeInfo.data))),
            onClone: _cache[27] || (_cache[27] = ($event: any) => (emit('clone-step', _ctx.nodeInfo.data))),
            onPasteStep: _cache[28] || (_cache[28] = ($event: any) => (emit('paste-step', _ctx.nodeInfo.data.id))),
            onToggleLock: _cache[29] || (_cache[29] = ($event: any) => (emit('toggle-lock', _ctx.nodeInfo.data))),
            onSkip: _cache[30] || (_cache[30] = ($event: any) => (emit('skip-step', _ctx.nodeInfo.data))),
            onEnable: _cache[31] || (_cache[31] = ($event: any) => (emit('enable-step', _ctx.nodeInfo.data))),
            clonedStep: _ctx.clonedStep,
            step: _ctx.nodeInfo,
            isLoop: isLoop.value,
            isLoopStep: isLoopStep.value,
            isRouterNode: isRouterNode.value,
            canAddAfterNode: canAddAfterNode(_ctx.nodeInfo?.data),
            isSkipped: skipMenuState.value.isSkipped,
            canSkip: skipMenuState.value.canSkip,
            canEnable: skipMenuState.value.canEnable,
            enableDisabled: skipMenuState.value.enableDisabled,
            isNextStepLoop: _ctx.isNextStepLoop,
            isNextStepLoopEnd: _ctx.isNextStepLoopEnd,
            nodes: _ctx.nodes,
            edges: _ctx.edges
          }, null, 8, ["anchorEl", "isMenuVisible", "selectedNodeId", "clonedStep", "step", "isLoop", "isLoopStep", "isRouterNode", "canAddAfterNode", "isSkipped", "canSkip", "canEnable", "enableDisabled", "isNextStepLoop", "isNextStepLoopEnd", "nodes", "edges"])
        ])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(Handle), {
      class: _normalizeClass(['custom-handle', { 'pointer-none': !_ctx.nodesDraggable }]),
      style: _normalizeStyle(getHandleStyle(_ctx.nodeInfo?.data)),
      position: _unref(Position).Right,
      type: "source",
      id: `${_ctx.nodeInfo.id}__handle-right`
    }, null, 8, ["class", "style", "position", "id"]),
    _createVNode(_unref(Handle), {
      class: _normalizeClass(["opacity-0 custom-handle", { 'pointer-none': !_ctx.nodesDraggable }]),
      style: _normalizeStyle(getHandleStyle(_ctx.nodeInfo?.data)),
      position: _unref(Position).Top,
      type: "source",
      id: `${_ctx.nodeInfo.id}__handle-top`
    }, null, 8, ["class", "style", "position", "id"]),
    (_ctx.nodeInfo?.data?.type === 'ROUTER')
      ? (_openBlock(), _createBlock(_unref(Handle), {
          key: 0,
          class: _normalizeClass(['custom-handle', { 'pointer-none': !_ctx.nodesDraggable }]),
          style: _normalizeStyle(getHandleStyle(_ctx.nodeInfo?.data)),
          position: _unref(Position).Bottom,
          id: `${_ctx.nodeInfo.id}__handle-bottom`
        }, null, 8, ["class", "style", "position", "id"]))
      : _createCommentVNode("", true),
    (_ctx.nodeInfo.type !== 'start')
      ? (_openBlock(), _createBlock(_unref(Handle), {
          key: 1,
          class: _normalizeClass(['custom-handle', { 'pointer-none': !_ctx.nodesDraggable }]),
          style: _normalizeStyle(getHandleStyle(_ctx.nodeInfo?.data)),
          type: "target",
          position: _unref(Position).Left,
          id: `${_ctx.nodeInfo.id}__handle-left`
        }, null, 8, ["class", "style", "position", "id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})